// SubmitButton.jsx
import React from 'react';
import PropTypes from 'prop-types';
import './SubmitButton.css';
import Spinner from '../Common/Spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const SubmitButton = ({ isLoading }) => {
  const { t } = useTranslation();

  return (
    <button type="submit" className="submit-button" disabled={isLoading} aria-label={t('submitButton.ariaLabel')}>
      {isLoading ? (
        <>
          <Spinner size="20px" color="#fff" /> {t('submitButton.sending')}
        </>
      ) : (
        t('submitButton.sendMessage')
      )}
    </button>
  );
};

SubmitButton.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};

export default SubmitButton;
